import { render, staticRenderFns } from "./detail_relatedCompanies.vue?vue&type=template&id=aac3f646&scoped=true&"
import script from "./detail_relatedCompanies.vue?vue&type=script&lang=js&"
export * from "./detail_relatedCompanies.vue?vue&type=script&lang=js&"
import style0 from "./detail_relatedCompanies.vue?vue&type=style&index=0&id=aac3f646&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "aac3f646",
  null
  
)

export default component.exports